<template>

  <div class="home">
  
    
  </div>

  
  

</template>

<script>


export default {
  name: 'Home',
  components: {
    
  },
  data(){
    return{
      code:'',
      local:window.location.href,
      access_token:'',
      user_info:{},
      form:{
        code:'',

      }


    }
  },
  created(){
    // this.getCode();
    // console.log(this.$route.query)
    document.title = '登录'
    // this.getCode();
    this.getCode();

  },
  methods:{
    // hasCookies(){
    //   if(!this.$cookies.isKey('token')){
    //     this.$router.push({name:'Login'});
    //   }

    // },
    getCode(){
      this.code=this.$route.query.code;
      //var code = getUrlParam('code');// 截取路径中的code，如果没有就去微信授权，如果已经获取到了就直接传code给后台获取openId
      console.log(this.code);
      if (this.code == null || this.code == ''||this.code == "undefined") {
        //window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid='+APPID+'&redirect_uri=' + encodeURIComponent(local) + '&response_type=code&scope=snsapi_base&state=#wechat_redirect';
        // window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wwc4c076f1a1d9ecb4&redirect_uri='+encodeURIComponent(this.local)+'&response_type=code&scope=snsapi_base&state=123#wechat_redirect';
        window.location.href = 'https://open.work.weixin.qq.com/wwopen/sso/qrConnect?appid=wwdec2a282cd543c92&agentid=1000002&redirect_uri='+encodeURIComponent(this.local)+'&state=STATE'
        return false;
      } else {
        this.getToken(); //把code传给后台获取用户信息
        return false;
      }
    },
    getToken(){
      this.form.code = this.code
      this.$http.post('get_token',this.form)
      .then((res)=>{
        // this.data = '222222222';
        console.log(res)
        this.data = res.data.data.token;
        localStorage.token=res.data.data.token;
        this.$cookies.set("token",res.data.data.token,"30D")
        this.$router.push({name:'Index'});
      })

    },


    // },
    // getAccessToken(){
    //   this.$http.post('https://admin.aomengqixiao.com/getaccesstoken')
    //   .then((res)=>{
    //     console.log(res)
    //     console.log(this.access_token)
    //     this.access_token = res.data.access_token
    //     this.approve.access_token = res.data.access_token
        
    //     this.getUserInfo();
    //   })

    // },
    // getUserInfo(){
    //   this.$http.post('https://admin.aomengqixiao.com/getuserinfo',{'access_token':this.access_token,'code':this.code})
    //   // this.$http.get('https://qyapi.weixin.qq.com/cgi-bin/user/getuserinfo?access_token='+this.access_token+'&code='+this.code)
    //   .then((res)=>{
    //     console.log(res)
    //     this.user_info = res.data
    //     this.approve.creator_userid= res.data.UserId
    //   })


    // },


  }
}
</script>
<style scoped>

.home{
  
  background:  url(/images/home_bg.jpg) repeat-x ;
  

}
.payment{
  margin:0px 10px 100px 10px;
  padding-top:10px;
}
</style>
<style>
.van-cell__title{
  font-size:1.2em;
  font-family:"Microsoft YaHei";
}
.van-cell__value{
  font-size:1.1em;
  font-family:"Microsoft YaHei";
}

</style>
